// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"135":"a0ec2a61","146":"4d4a2528","480":"e1605179","551":"bd0d9dac","821":"31e79ac5","999":"1c9c9910"}[chunkId] + ".chunk.css";
};